<template>
  <transition
    appear
    enter-active-class="ease-in-out duration-100 transform"
    enter-from-class="-translate-x-full"
    enter-to-class="translate-x-0"
    leave-active-class="ease-in-out duration-100 transform"
    leave-from-class="translate-x-0"
    leave-to-class="-translate-x-full"
  >
    <div class="absolute left-80px top-0 h-full w-340px flex flex-col bg-white shadow-btn-card">
      <div v-if="isClosable" class="flex justify-end px-16px py-12px">
        <i
          class="icon-close cursor-pointer text-24px text-primary-80"
          @click="$emit('closePanel')"
        />
      </div>
      <slot name="header" />
      <div class="scrollbar flex-1 overflow-x-hidden overflow-y-auto">
        <slot name="content" />
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    isClosable?: boolean
  }>(),
  {
    isClosable: false,
  },
)

defineEmits<{
  closePanel: () => void
}>()
</script>
